// removed by extract-text-webpack-plugin
module.exports = {"container":"IconCard__container___12rBU","card-title":"IconCard__card-title___y36He","image":"IconCard__image___2NLlp"};